import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { RoleGuardService } from '@cvx/cal-angular';
import { CalService } from '../services/cal.service';
import { firstValueFrom, isObservable } from 'rxjs';
import { CommonService } from '../services/common.service';

export const customRoleGuard: CanActivateFn = async (route, state) => {
    const roleGuard = inject(RoleGuardService);
    const router = inject(Router);
    const calService = inject(CalService);
    const commonService = inject(CommonService);

    try {
        const isSignedIn: boolean = await calService.isUserSignedIn();
        
        if (isSignedIn) {
            const result = roleGuard.canActivate(route);
            
            // Handle Observable or Promise return types
            const canActivate = isObservable(result) 
                ? await firstValueFrom(result)
                : await Promise.resolve(result);
            
            if (canActivate) {
                return canActivate;
            }
            else {
                let cRoles = commonService?.cRoles?.length ? commonService.cRoles[0] : '';
                if(['NMAFSM.Admin', 'NMAFSM.DataEntry', 'NMAFSM.ReportsAndData' ].includes( cRoles))
                    router.navigate(['/foundation/home']);
                else if(['NMAFSM.ReportViewer' ].includes(cRoles))
                    router.navigate(['/reporting']);
                else
                    router.navigate(['/access-denied']);

                return false;
            }
        } else {
            return false;
        }
        
    } catch (error) {
        console.error('Error checking sign-in status:', error);
        router.navigate(['/bye-bye']);
        return false;
    }
};
